// extracted by mini-css-extract-plugin
export default {"rules-content":"Rules_rules-content__FHJ1x"};